import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { closeEmailConversation } from 'common/store/genesys-cloud/conversations/emails/actions/email-conversation.actions';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { ConfirmationModalConfig } from 'shared/components/confirmation-modal/confirmation-modal-config';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';

@Component({
  selector: 'app-genesys-email-close-confirmation-modal',
  templateUrl: './genesys-email-close-confirmation-modal.component.html',
  styleUrls: ['./genesys-email-close-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailCloseConfirmationModalComponent {
  readonly confirmationBoxConfig: ConfirmationModalConfig = {
    title: 'genesysEmailCloseConfirmationModal.closeEmailConfirmationTitle',
    buttonTitle: 'genesysEmailCloseConfirmationModal.yes',
    secondaryActionTitle: 'genesysEmailCloseConfirmationModal.dontShowAgain',
    cancelTitle: 'genesysEmailCloseConfirmationModal.continue'
  };

  @Input() conversationId: string;
  @Output() closeConfirmationModal = new EventEmitter();

  constructor(
    private readonly _closingConfirmationService: ClosingConfirmationService,
    private readonly _rxEmitter: RxEmitter,
    private readonly store: Store
  ) {}

  closeConfirmation(): void {
    this.closeConfirmationModal.emit();
  }

  onConversationClosed(): void {
    this.store.dispatch(closeEmailConversation({ conversationId: this.conversationId }));
    this.closeConfirmation();
  }

  closeConversationAndTurnOffModal(): void {
    this._closingConfirmationService.setClosingConfirmation(WorkItemTypes.GENESYS_EMAIL, true);
    this._rxEmitter.send(MessageBusEvents.ShowConfirmationPanelTooltip, null);
    this.onConversationClosed();
  }
}
